const element = document.getElementById('SortBy');
const choices = new Choices(element, {
  searchEnabled: false,
  itemSelectText: '',
  allowHTML: true,
  labelId: 'SortBy-label'
});

// Fix Choices.js ARIA issues:
// 1. aria-selected on display items (not role=option) — remove it
// 2. aria-controls missing — link combobox to its listbox so Axe can resolve the owned role
(function fixChoicesA11y(instance) {
  var container = instance.containerOuter.element;
  var dropdown = container.querySelector('.choices__list--dropdown');
  if (dropdown) {
    if (!dropdown.id) dropdown.id = 'SortBy-listbox';
    container.setAttribute('aria-controls', dropdown.id);
  }
  function clearAriaSelected() {
    container.querySelectorAll('.choices__list--single .choices__item').forEach(function(item) {
      item.removeAttribute('aria-selected');
    });
  }
  clearAriaSelected();
  element.addEventListener('change', clearAriaSelected);
})(choices);

class MatatFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.querySelector('button.button').addEventListener('click', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    facetForm.querySelector('.matat-filters__close').addEventListener('click', ()=> {
      facetForm.querySelector('.filter-opener').dispatchEvent(new Event('click'));
    });
    document.querySelector('#SortBy').addEventListener('change', function(e){
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      MatatFiltersForm.renderPage(url.searchParams.toString());
    });
    document.querySelector('#MatatFiltersForm').classList.add('loaded');
    document.querySelector('#ProductGridContainer').classList.add('loaded');
  }

  connectedCallback() {
    MatatFiltersForm.priceRangeSlider();
    // MatatFiltersForm.getCollectionsColor();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : MatatFiltersForm.searchParamsInitial;
      if (searchParams === MatatFiltersForm.searchParamsPrev) return;
      MatatFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    MatatFiltersForm.searchParamsPrev = searchParams;
    const sections = MatatFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      MatatFiltersForm.filterData.some(filterDataUrl) ?
        MatatFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        MatatFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) MatatFiltersForm.updateURLHash(searchParams);
  }

static renderSectionFromFetch(url, event) {
  fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      MatatFiltersForm.filterData = [...MatatFiltersForm.filterData, { html, url }];
      MatatFiltersForm.renderFilters(html, event);
      MatatFiltersForm.renderProductGridContainer(html);
      MatatFiltersForm.renderProductCount(html);
    })
    .then(() => {
      MatatFiltersForm.priceRangeSlider();
      MatatFiltersForm.initFlickity();   // <--- here
    });
}

static renderSectionFromCache(filterDataUrl, event) {
  const html = MatatFiltersForm.filterData.find(filterDataUrl).html;
  MatatFiltersForm.renderFilters(html, event);
  MatatFiltersForm.renderProductGridContainer(html);
  MatatFiltersForm.renderProductCount(html);
  MatatFiltersForm.priceRangeSlider();
  MatatFiltersForm.initFlickity();       // <--- and here
}


  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    if(document.getElementById('ProductCount')){
      const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
      const container = document.getElementById('ProductCount');
      container.innerHTML = count;
      container.classList.remove('loading'); 
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#MatatFiltersForm .js-filter, #MatatFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    MatatFiltersForm.renderActiveFacets(parsedHTML);
    MatatFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) MatatFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    MatatFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  static priceRangeSlider() {
    const myRangeInput = document.getElementById('matat-range-slider');
    if(myRangeInput){
      const rangeable = new Rangeable(myRangeInput, {
        type: "double",
        tooltips: false,
        step: 1,
        value: [myRangeInput.dataset.min, myRangeInput.dataset.max],
        vertical: false,
        handle: undefined,
        handles: undefined,
        onInit: function(value) {
          document.getElementById('Filter-Price-GTE').value = value[0];
          document.getElementById('Filter-Price-LTE').value = value[1];
          document.getElementById('selectedPriceMin').textContent = value[0];
          document.getElementById('selectedPriceMax').textContent = value[1];
        },
        onChange: function(value) {
          document.getElementById('Filter-Price-GTE').value = value[0];
          document.getElementById('Filter-Price-LTE').value = value[1];
          document.getElementById('selectedPriceMin').textContent = value[0];
          document.getElementById('selectedPriceMax').textContent = value[1];
        }
      });
    }
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    MatatFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('matat-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'MatatFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'MatatFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'MatatFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
    MatatFiltersForm.priceRangeSlider();
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    MatatFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    MatatFiltersForm.renderPage(url);
  }

  static getCollectionsColor() {
    // Removed: This method used a hardcoded Storefront API token and store URL.
    // To re-enable, use dynamic store URL and pass the token from theme settings.
  }

  static initFlickity() {
  if (document.querySelector('.flikity_grid_image')) {
    document.querySelectorAll('.flikity_grid_image').forEach((slide) => {
      new Flickity(slide, {
        imagesLoaded: true,
        rightToLeft: true,
        cellAlign: "right",
        pageDots: false,
        wrapAround: true,
        draggable: false,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              freeScroll: true,
              wrapAround: false,
              contain: true,
              prevNextButtons: true,
              draggable: false,
              pageDots: false
            }
          }
        ]
      });
    });
  }
}

}

MatatFiltersForm.filterData = [];
MatatFiltersForm.searchParamsInitial = window.location.search.slice(1);
MatatFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('matat-filters-form', MatatFiltersForm);
MatatFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input:not([type="range"])')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class MatatFilterRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('matat-filters-form') || document.querySelector('matat-filters-form');
    form.onActiveFilterClick(event);
    if(event.target.classList.contains('facets__clear')) {
      form.querySelector('.filter-opener').dispatchEvent(new Event('click'));
    }
    MatatFiltersForm.priceRangeSlider();
  }
}

customElements.define('matat-filter-remove', MatatFilterRemove);

window.addEventListener('scroll', () => {
  if(document.querySelectorAll('.facet-filters.sorting')){
       document.querySelectorAll('.facet-filters.sorting .choices').forEach(choice => {
        if (choice.classList.contains('is-open') || choice.classList.contains('is-flipped') || choice.classList.contains('is-focused')) {
          document.querySelector('.collection-nav-bar-main').click()
        }
    });                        
  }
});

document.addEventListener('click', (event) => {
  const summary = event.target.closest('summary');
  if (!summary) return;

  // For filter summaries
  if (summary.classList.contains('matat_filters__summary')) {

    // Re-init range slider
    const sliderWrapper = document.getElementById('matat-range-slider');
    if (sliderWrapper?.rangeable) {
      sliderWrapper.rangeable.destroy?.();
      sliderWrapper.style.display = 'none';
      sliderWrapper.offsetHeight; // force reflow
      sliderWrapper.style.display = '';
      MatatFiltersForm.priceRangeSlider();
    }
  }
});